export enum SessionStorageKey {
  PAYMENT_RESPONSE = 'robynpay_pr',
}

export const SessionStorageMethod = {
  GET_ITEM: 'getItem',
  SET_ITEM: 'setItem',
  REMOVE_ITEM: 'removeItem',
} as const satisfies Record<string, string>;

export type SessionStorageMethod =
  (typeof SessionStorageMethod)[keyof typeof SessionStorageMethod];
